import styled from "@emotion/styled";
import { Section } from "../layout/section";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import { breakpoints } from "../../styles/breakpoints";

const StyledWhy = styled.div`
  display: flex;
  align-items: center;
  gap: var(--large);

  @media(max-width: ${breakpoints.lg}) {
    gap: var(--medium);
  }

  @media(max-width: ${breakpoints.md}) {
    flex-direction: column;
    max-width: 600px;
    margin: auto;
  }

  .wrapper {
    flex: 0 0 550px;

    @media(max-width: ${breakpoints.lg}) {
      flex: 0 0 400px;
    }
  }

  p {
    margin: var(--mini) 0;
  }
`;

export const Why = () => (
  <Section>
    <div className="row">
      <StyledWhy>
        <div className="wrapper">
          <StaticImage
            src="../../images/seo/why.png"
            alt="Why Agencies Choose Agency Elevation"
          />
        </div>
        <div className="text">
          <h2 className="h2">Why Agencies Choose Agency Elevation</h2>
          <p>
            Agencies of all sizes choose Agency Elevation as the white label SEO
            company of choice because of our 100% USA-based team and vast
            experience in helping agencies scale while delivering massive
            results. If you’re looking for a white label SEO provider, then here
            are a few of many reasons why successful agencies choose&nbsp;us!
          </p>
          <Link to="/contact" className="btn-brand">
            Contact Us
          </Link>
        </div>
      </StyledWhy>
    </div>
  </Section>
);
